import axios, { AxiosResponse } from "axios";
import { useSession } from "next-auth/react";
import useSWR from "swr";
import { SubscriptionAddonSchema } from "types/addons";

const key = "/api/customer/addons";

export const useSubscriptionAddons = () => {
  const { data: session } = useSession();

  const { data, error } = useSWR<AxiosResponse<SubscriptionAddonSchema[]>>(
    session ? key : null,
    axios.get
  );

  return {
    addons: data?.data,
    isAddonsLoading: !error && !data,
    isAddonsError: error,
  };
};

export const redirectToStripeAddonsCheckout = async (
  priceId: string,
  options?: {
    onBehalfWorkspaceId?: string;
    cancelCallbackPath?: string;
    successCallbackPath?: string;
  }
) => {
  const response = await axios.post<{ url: string }>("/api/checkout/addons", {
    priceId,
    onBehalfWorkspaceId: options?.onBehalfWorkspaceId,
    successCallbackPath: options?.successCallbackPath,
    cancelCallbackPath: options?.cancelCallbackPath,
  });
  return response;
};
